"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _axios = _interopRequireDefault(require("axios"));

var _header = _interopRequireDefault(require("../../control-components/header"));

var _BadgeSelector = _interopRequireDefault(require("./BadgeSelector"));

var _panel = _interopRequireDefault(require("../../control-components/panel"));

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _UserSelector = _interopRequireDefault(require("../user-selector/UserSelector"));

var _Loader = _interopRequireDefault(require("../../control-components/ui-components/Loader"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MAX_NUMBER_USERS = 50;
var errorMessages = {
  noBadge: 'Please select a badge',
  noContent: 'Please add at least one user',
  userLimitExceeded: "Please select a maximum of ".concat(MAX_NUMBER_USERS, " users")
};

var AwardBadge = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AwardBadge, _Component);

  var _super = _createSuper(AwardBadge);

  function AwardBadge(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AwardBadge);
    _this = _super.call(this, props);
    _this.state = {
      badgesList: null,
      selectedBadge: null,
      users: [],
      backendErrors: {
        errorMessage: null,
        messageType: null
      },
      errors: {},
      loading: false
    };
    _this.awardBadge = _this.awardBadge.bind((0, _assertThisInitialized2.default)(_this));
    _this.onUsersChange = _this.onUsersChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onBadgeSelected = _this.onBadgeSelected.bind((0, _assertThisInitialized2.default)(_this));
    _this.trackBadgeAwardedEvent = _this.trackBadgeAwardedEvent.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(AwardBadge, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var response;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _axios.default.get('/settings/badge/getBadgesList');

              case 2:
                response = _context.sent;
                this.setState({
                  badgesList: response.data
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "awardBadge",
    value: function () {
      var _awardBadge = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this2 = this;

        var _this$state, selectedBadge, users, userLimitExceeded, noUserSelected;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState({
                  backendErrors: {
                    errorMessage: null,
                    messageType: null
                  },
                  errors: {}
                });
                _this$state = this.state, selectedBadge = _this$state.selectedBadge, users = _this$state.users;
                userLimitExceeded = users.length > MAX_NUMBER_USERS;
                noUserSelected = users.length === 0;

                if (!(!selectedBadge || noUserSelected || userLimitExceeded)) {
                  _context2.next = 7;
                  break;
                }

                this.handleErrors(!selectedBadge, noUserSelected, userLimitExceeded);
                return _context2.abrupt("return");

              case 7:
                this.setState({
                  loading: true
                });
                _context2.next = 10;
                return _axios.default.post('/settings/badge/award', {
                  badgeId: selectedBadge,
                  userNames: users.map(function (user) {
                    return user.name;
                  })
                }).then(function (resolve) {
                  if (resolve.data.error) {
                    _this2.setState({
                      backendErrors: {
                        errorMessage: resolve.data.error,
                        messageType: 'error'
                      },
                      loading: false
                    });
                  } else {
                    users.forEach(function (user) {
                      _this2.trackBadgeAwardedEvent(selectedBadge, user.id, user.name, user.mainRole, users.length);
                    });
                    window.location.assign('/settings/badge/overview?badgeAwarded');
                  }
                }).catch(function () {
                  _this2.setState({
                    backendErrors: {
                      errorMessage: 'Something went wrong please try again later.',
                      messageType: 'error'
                    },
                    loading: false
                  });
                });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function awardBadge() {
        return _awardBadge.apply(this, arguments);
      }

      return awardBadge;
    }()
  }, {
    key: "handleErrors",
    value: function handleErrors(isNotBadgeSelected, noUserSelected, userLimitExceeded) {
      if (isNotBadgeSelected) {
        this.setState({
          errors: _objectSpread(_objectSpread({}, this.state.errors), {}, {
            badge: errorMessages.noBadge
          })
        });
      }

      if (noUserSelected) {
        this.setState({
          errors: _objectSpread(_objectSpread({}, this.state.errors), {}, {
            usersInput: errorMessages.noContent
          })
        });
      }

      if (userLimitExceeded) {
        this.setState({
          errors: _objectSpread(_objectSpread({}, this.state.errors), {}, {
            usersInput: errorMessages.userLimitExceeded
          })
        });
      }
    }
  }, {
    key: "trackBadgeAwardedEvent",
    value: function trackBadgeAwardedEvent(selectedBadgeID, awardedId, awardedUsername, awardedRole, numberOfUsersAwarded) {
      var badgesList = this.state.badgesList;
      var _this$props = this.props,
          awarderId = _this$props.awarderId,
          awarderUsername = _this$props.awarderUsername,
          awarderRole = _this$props.awarderRole;
      if (!badgesList) return;
      var awardedBadge = badgesList.find(function (badge) {
        return badge.id.toString() === selectedBadgeID;
      });
      if (!awardedBadge) return;

      _publish.default.trackEvent('userevent', {
        type: 'Badge Awarded',
        badgeId: awardedBadge.id,
        badgeName: awardedBadge.title,
        badgeDescription: awardedBadge.description,
        awarderId: awarderId,
        awarderUsername: awarderUsername,
        awarderRole: awarderRole,
        awardedId: awardedId,
        awardedUsername: awardedUsername,
        awardedRole: awardedRole,
        numberOfUsersAwarded: numberOfUsersAwarded
      });
    }
  }, {
    key: "onUsersChange",
    value: function onUsersChange(users) {
      this.setState({
        users: users,
        errors: _objectSpread(_objectSpread({}, this.state.errors), {}, {
          usersInput: undefined
        })
      });
    }
  }, {
    key: "onBadgeSelected",
    value: function onBadgeSelected(badgeId) {
      this.setState({
        selectedBadge: badgeId,
        errors: _objectSpread(_objectSpread({}, this.state.errors), {}, {
          badge: undefined
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var state = this.state;
      if (!state.badgesList) return null;
      return (0, _preact.h)("div", null, state.loading && (0, _preact.h)(_Loader.default, null), state.backendErrors.errorMessage && state.backendErrors.messageType && (0, _preact.h)(_AlertComponent.default, {
        messageType: state.backendErrors.messageType,
        message: state.backendErrors.errorMessage,
        sticky: true
      }), (0, _preact.h)(_header.default, {
        title: "Award badge to users",
        disableSaveButton: true,
        disableCancelButton: true,
        customButtons: [{
          title: 'Cancel',
          variant: 'secondary',
          action: function action() {
            return window.location.assign('/settings/badge/overview');
          }
        }, {
          title: 'Award',
          variant: 'primary',
          action: this.awardBadge
        }]
      }), (0, _preact.h)("div", {
        className: "award-badge"
      }, (0, _preact.h)(_panel.default, {
        customClass: "award-badge--panel"
      }, (0, _preact.h)("div", null, (0, _preact.h)("label", null, "Badge"), (0, _preact.h)(_BadgeSelector.default, {
        badges: state.badgesList,
        selected: state.badgesList.find(function (badge) {
          return badge.id.toString() === state.selectedBadge;
        }),
        onChange: this.onBadgeSelected,
        error: state.errors.badge
      })), (0, _preact.h)("br", null), (0, _preact.h)("div", null, (0, _preact.h)("label", null, "To"), (0, _preact.h)("p", null, "Choose one or more (max. ".concat(MAX_NUMBER_USERS, ") users. Separate multiple users by comma. Example: John, Jane, Jack")), (0, _preact.h)(_UserSelector.default, {
        url: "/member/getUsers?query=",
        onChange: function onChange(users) {
          return _this3.onUsersChange(users);
        },
        error: !!state.errors.usersInput
      }), state.errors.usersInput && (0, _preact.h)("span", {
        className: "error"
      }, state.errors.usersInput)))));
    }
  }]);
  return AwardBadge;
}(_preact.Component);

var _default = AwardBadge;
exports.default = _default;